import { request } from './helpers/request'
import { GENERIC_INVITATION_ERROR_CODE } from '../constants/error.codes'

export const confirmInvitation = (data) =>
  request({
    url: `/users/invitation/accept/${data.token}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
    },
    data: new URLSearchParams(data).toString(),
  }).then((response) => {
    if (response.status === 200) {
      return Promise.resolve(response.data)
    } else if (response.status === 400) {
      return Promise.reject(new Error(response.data.code))
    } else {
      return Promise.reject(new Error(GENERIC_INVITATION_ERROR_CODE))
    }
  })
